import { SellerRegionEnum } from '../region';
var getMCNArticleId = function getMCNArticleId(region) {
  switch (region) {
    case SellerRegionEnum.GB:
      return '10014442';
    case SellerRegionEnum.TH:
      return '10015359';
    default:
      return '';
  }
};
var config = {
  getMCNArticleId: getMCNArticleId,
  ConnectionConfigKey: 'affiliate_connection_submodule_local_config'
};
export default config;